module.exports = __webpack_public_path__ + "static/man_set_3gradeschooler.fd7b1c17.svg";